import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';

import { Subscription, filter, tap } from 'rxjs';

import { Location } from '@shared/location/models';
import { WhoService } from '../../../../../services';
import { AppIcon, AppIconSize } from '@tablesready/frontend-icons';
import { AuthRestaurantService } from '@tablesready/frontend-store';

@Component({
  selector: 'tablesready-public-api',
  templateUrl: './api.component.html',
})
export class ApiComponent implements OnInit, OnDestroy, OnChanges {
  @Input() disabled: boolean = true;
  icon = AppIcon;
  size = AppIconSize;
  location: Location;
  form: UntypedFormGroup;
  sending = false;

  private readonly subscriptions = new Subscription();

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly whoService: WhoService,
    private readonly authRestaurantService: AuthRestaurantService,
  ) {
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      enabled: [false, [Validators.required]],
    });
    this.toggleFormEnabled();
    const publicApiEnabledSubscription = this.form.controls.enabled.valueChanges
      .pipe(tap(value => {
        if (value) {
          this.form.addControl('apiKey', new UntypedFormControl(this.location.publicWaitlist.apiKey || ''));
        } else {
          this.form.removeControl('apiKey');
        }
      }))
      .subscribe();
    this.subscriptions.add(publicApiEnabledSubscription);

    const userSubscription = this.authRestaurantService.select()
      .pipe(
        filter(user => user.location !== undefined),
        tap(({location}) => {
          this.location = location;
          this.form.patchValue({
            enabled: this.location.publicWaitlist.api,
            apiKey: this.location.publicWaitlist.apiKey,
          });
        }),
      ).subscribe();

    this.subscriptions.add(userSubscription);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.disabled?.previousValue !== undefined) {
      this.toggleFormEnabled();
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  save() {
    this.whoService.updatePublicApi(this.form.value)
      .pipe(tap(() =>  this.form.markAsPristine()))
      .subscribe()
  }

  private toggleFormEnabled() {
    if (!this.form) {
      return;
    }

    if (this.disabled) {
      this.form.disable({onlySelf: true, emitEvent: false});
    } else {
      this.form.enable({onlySelf: true, emitEvent: false});
    }
  }
}
